const BILLING_BASE = import.meta.env.DEV ? '' : 'https://invoicing-service-backend.zivux.ai';
const BILLING_PUB_KEY = 'zxpub_9f3a1b2c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9';

async function billingApi(path, opts = {}) {
  // Inject _pub into every JSON body so the server returns plain (unencrypted) responses
  let body = opts.body;
  if (body && typeof body !== 'string') {
    body = JSON.stringify({ ...body, _pub: BILLING_PUB_KEY });
  } else if (!body) {
    body = JSON.stringify({ _pub: BILLING_PUB_KEY });
  }

  const res = await fetch(`${BILLING_BASE}${path}`, {
    ...opts,
    headers: {
      'Content-Type': 'application/json',
      ...opts.headers,
    },
    body,
  });
  const ct   = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json().catch(() => null) : await res.text();
  if (!res.ok) {
    const errMsg = data?.message || data?.error?.message || data?.error;
    throw new Error(typeof errMsg === 'string' ? errMsg : `HTTP ${res.status}`);
  }
  return data;
}

export const billingPost = (path, body) => billingApi(path, { method: 'POST', body });
